import { useEffect } from 'react';
import { setTags, setUser } from '@sentry/react';
import { isPresent } from 'utils/isPresent';

import ProIdentity from 'components/ProIdentity/ProIdentity';

export const useSetSentryUserIdentity = (isProFetched: boolean, proData: ProIdentity) => {
  useEffect(() => {
    if (isProFetched && isPresent(proData)) {
      const proIdentity = {
        id: proData.id,
        username: proData.full_name,
        email: proData.email,
        organizationId: proData.organization_uuid,
      };

      setUser(proIdentity);
      setTags({
        uuid: proData.uuid,
        orgName: proData.organization_name,
        impersonated: proData.impersonated,
        isAdmin: proData.is_admin,
        isArchived: proData.is_archived,
        isSuperPro: proData.is_super_pro,
      });
    }
  }, [isProFetched, proData]);
};
